// extracted by mini-css-extract-plugin
module.exports = {"navTabContainer":"navTabs_navTabContainer__yQfZE","navTabButton":"navTabs_navTabButton__2kw8X"};